import React from "react";
import {
  Dialog,
  Typography,
  Box,
  IconButton,
  makeStyles,
  DialogTitle,
  DialogContent,
  Grid,
  Divider,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import * as Yup from "yup";
import { Formik } from "formik";
import useScriptRef from "../../hooks/useScriptRef";
import CustomButton from "../../components/CustomButton";
import CustomTextField from "../../components/CustomTextField";
import ThemeColors from "../../config/colors";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles(() => ({
  titleBackground: {
    backgroundColor: ThemeColors.dialogTitleBackground,
  },
}));

const OpenVideoDialog = ({ open = false, setOpen }) => {
  const classes = useStyles();

  const navigate = useNavigate();

  const scriptedRef = useScriptRef();

  const onSubmit = (id) => {
    setOpen(false);
    navigate("/interactive-video?id=" + id);
  };

  const openDemo = () => {
    setOpen(false);
    navigate("/interactive-video?demo=true");
  };

  return (
    <Dialog
      onClose={() => setOpen(false)}
      open={open}
      PaperProps={{
        style: { borderRadius: 14 },
      }}
      fullWidth
    >
      <DialogTitle className={classes.titleBackground}>
        <Box className="d-flex align-items-center justify-content-between">
          <Typography variant="h4" className="font-weight-semibold mx-3">
            Choose Scenario
          </Typography>

          <IconButton onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Formik
          initialValues={{
            id: "",
            submit: null,
          }}
          validationSchema={Yup.object().shape({
            id: Yup.string().required("Field is required"),
          })}
          onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
            try {
              onSubmit(values?.id);

              if (scriptedRef.current) {
                setStatus({ success: true });
                setSubmitting(false);
              }
            } catch (err) {
              console.error(err);
              if (scriptedRef.current) {
                setStatus({ success: false });
                setErrors({ submit: err.message });
                setSubmitting(false);
              }
            }
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            isSubmitting,
            touched,
            values,
          }) => (
            <form
              className="d-flex flex-column justify-content-center align-items-center px-5 py-4"
              noValidate
              onSubmit={handleSubmit}
            >
              <Grid container>
                <Grid
                  item
                  xs
                  className="d-flex align-items-center justify-content-center"
                >
                  <CustomButton
                    title="Open Demo"
                    color="default"
                    disabled={isSubmitting}
                    onClick={openDemo}
                  />
                </Grid>

                <Divider orientation="vertical" flexItem />

                <Grid item xs className="mx-4">
                  <CustomTextField
                    id="id"
                    title="Scenario Id"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.id}
                    error={errors.id}
                    touched={touched.id}
                  />

                  {errors.submit && (
                    <Typography
                      className="mt-4 mb-2"
                      color="error"
                      variant="body2"
                    >
                      {errors.submit}
                    </Typography>
                  )}

                  <CustomButton
                    title="Confirm"
                    disabled={isSubmitting}
                    type="submit"
                    className="w-100 mt-3"
                  />
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default OpenVideoDialog;
